import { surveyInstance } from '..';

const getClientAnswers = async (id) => {
  const { data } = await surveyInstance(`/answers/client/${id}`);
  return data;
};

export default getClientAnswers;
